import styled from 'styled-components/macro';
import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { useDispatch, useSelector } from 'react-redux';
import TextHeader from 'components/CustomText/TextHeader';
import NumberListFormItem from 'components/Application/InitialApplication/NumberListFormItem';
import CustomCheckbox from 'components/CustomCheckbox';
import CustomButton from 'components/CustomInput/Button';
import { useHistory } from 'react-router';
import { setGlobal } from 'store/global/reducer';
import CloseIcon from '@material-ui/icons/Close';

const SLayout = styled.div``;

const SContent = styled.div`
    min-width: 400px;
    display: relative;
    /* font-weight: normal; */
`;

const SHeader = styled.div`
    text-align: center;
`;

const SSubHeader = styled.div`
    margin-top: 40px;
`;

const SHighlightHeader = styled.div`
    text-decoration: underline;
    margin-top: 15px;
`;

const SCloseButtonLayout = styled.div`
    position: absolute;
    top: 20px;
    right: 30px;
`;

const AlertMessage = (props) => {
    const isShow = useSelector((state) => state.global.isShowAlertWindow);
    const history = useHistory();
    const [isAgree, setAgree] = useState(false);
    const dispatch = useDispatch();

    return (
        <SLayout>
            <Dialog
                open={isShow ?? false}
                fullWidth
                maxWidth={'lg'}
                onClose={() => {
                    dispatch(
                        setGlobal({
                            isShowAlertWindow: false,
                        }),
                    );
                }}
            >
                <DialogContent>
                    <SContent>
                        <SCloseButtonLayout>
                            <CloseIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    dispatch(
                                        setGlobal({
                                            isShowAlertWindow: false,
                                        }),
                                    );
                                }}
                            />
                        </SCloseButtonLayout>

                        <SHeader>
                            <TextHeader>Important Notes: Roles and Responsibilities</TextHeader>
                        </SHeader>
                        <SSubHeader>
                            <TextHeader>“Coordinating Investigator” should:</TextHeader>
                        </SSubHeader>

                        <NumberListFormItem
                            number={'-'}
                            label={
                                'be either Site Principal Investigator (Site PI) or Co-Investigator (Co-I) of the applying sites'
                            }
                        />

                        <NumberListFormItem number={'-'} label={'have thorough understanding of the study protocol'} />

                        <NumberListFormItem
                            number={'-'}
                            label={
                                'complete the study-based information of the Application Form and provide study-based application documents'
                            }
                        />

                        <NumberListFormItem
                            number={'-'}
                            label={'coordinate with Site PIs to submit the Initial Application for review'}
                        />

                        <NumberListFormItem
                            number={'-'}
                            label={
                                'submit study-based Post-approval Applications (e.g. Final Report, SUSAR Report, Study-based Amendment, CTC/CTI etc.)'
                            }
                        />

                        <SSubHeader>
                            <TextHeader>“Site Principal Investigator (Site PI)” should:</TextHeader>
                        </SSubHeader>

                        <NumberListFormItem
                            number={'-'}
                            label={'take responsibility for the conduct of study at his/her study site'}
                        />

                        <NumberListFormItem
                            number={'-'}
                            label={
                                'fill in site-specific information of the Application Form and to provide site-specific application documents (e.g. CV, declaration form etc.) and relevant signature pages'
                            }
                        />

                        <NumberListFormItem
                            number={'-'}
                            label={
                                'submit site-specific Post-approval Applications (e.g. Progress Report, Local SAE Report, Protocol Deviation / Compliance Incident Report, Site-specific Amendment etc.)'
                            }
                        />

                        <SSubHeader>
                            <TextHeader>Eligibility of “Coordinating Investigator” and “Site PI”:</TextHeader>
                        </SSubHeader>

                        <SHighlightHeader>For Central IRB:</SHighlightHeader>
                        <NumberListFormItem number={'-'} label={'shall be an employee/appointee of HA'} />

                        <SHighlightHeader>For HKU/HA HKW IRB:</SHighlightHeader>
                        <NumberListFormItem
                            number={'-'}
                            label={'shall be an employee/appointee/student of the HKU or HA Hong Kong West Cluster'}
                        />

                        <SHighlightHeader>For the Joint CUHK-NTEC CREC:</SHighlightHeader>
                        <NumberListFormItem
                            number={'-'}
                            label={
                                'shall be an employee/appointee/student of the CUHK or HA New Territories East Cluster'
                            }
                        />

                        <SSubHeader>
                            <TextHeader>Reminders: </TextHeader>
                        </SSubHeader>

                        <NumberListFormItem
                            number={'1'}
                            label={
                                'For studies involving HKU/CUHK, separate ethics approval from HKU/HA HKW IRB or the Joint CUHK-NTEC CREC might be required. Please approach respective IRB/CREC for details.'
                            }
                        />

                        <NumberListFormItem
                            number={'2'}
                            label={
                                'Information submitted in this CRER Portal can be viewed by the Coordinating Investigator, all Site PIs and respective delegates.'
                            }
                        />

                        <SSubHeader>
                            <CustomCheckbox
                                onItemChange={(key, checked) => {
                                    setAgree(checked);
                                }}
                                value={[isAgree]}
                                defaultData={[
                                    {
                                        key: true,
                                        display: 'Acknowledgement of the Important Notes and Reminders above. ',
                                    },
                                ]}
                            />
                        </SSubHeader>

                        <SSubHeader>
                            <CustomButton
                                onClick={() => {
                                    dispatch(
                                        setGlobal({
                                            isShowAlertWindow: false,
                                        }),
                                    );

                                    // rollback the form
                                    setAgree(false);

                                    history.push('/applications/new');
                                }}
                                tooltip={'please acknowledge before continue'}
                                disabled={!isAgree}
                                showToolTipInDisabledOnly
                            >
                                Continue
                            </CustomButton>
                        </SSubHeader>
                    </SContent>
                </DialogContent>
            </Dialog>
        </SLayout>
    );
};

export default AlertMessage;
